<div class="flex flex-column ppg-color-details">
  @if (breadcrumbs()) {
    <section>
      <ppg-breadcrumbs [breadcrumbs]="breadcrumbs()!" [rootName]="breadcrumbsHome()" />
    </section>
  }

  @if (colorDetails()) {
    <section class="section-container">
      <div class="grid">
        <div
          #headerBannerContainer
          data-test-id="colorDetails.smallScreenHeaderBannerContainer"
          class="col-12 block lg:hidden">
          <ng-container *ngTemplateOutlet="headerBanner" />
        </div>
        <div class="col-12 lg:col-6">
          <!-- Left content section -->
          <div class="flex flex-column gap-3">
            <ppg-galleria
              class="z-1"
              [showItemNavigators]="true"
              [showThumbnails]="true"
              [ngStyle]="{
                '--desktop-header-banner-height': desktopHeaderHeight(),
              }"
              [ngClass]="{
                'lg:mt-6': galleriaImages().length,
                'lg:mt-0 galeria-empty-container': !galleriaImages().length,
              }"
              [images]="galleriaImages()"
              (startVideoClick)="startVideoClickHandler($event)"
              (thumbnailClick)="onGalleriaItemChange($event)"
              data-test-id="colorDetails.galleria" />
            @if (ctaLaunchColorVisualizer()?.content?.url) {
              <p-card styleClass="w-full" class="z-1">
                <div class="flex flex-column">
                  <h5 data-test-id="colorDetailsPage.launchColorVisualizerHeadline" class="font-bold">
                    {{ resources().launchColorVisualizerHeadline }}
                  </h5>
                  <p-button
                    data-test-id="colorDetailsPage.launchColorVisualizerButton"
                    class="mt-3"
                    styleClass="w-full flex justify-content-center"
                    (onClick)="navigateToLaunchColorVisualizer(ctaLaunchColorVisualizer())">
                    <div class="flex flex-row align-items-center gap-2">
                      <span data-test-id="colorDetailsPage.launchColorVisualizerButton.label">{{
                        ctaLaunchColorVisualizer()?.content?.text
                      }}</span>
                      <span [class]="PrimeIcons.ARROW_UP_RIGHT" style="font-size: inherit"></span>
                    </div>
                  </p-button>
                </div>
              </p-card>
            }
            @if (colorWarranty()) {
              <ppg-color-warranty
                class="hidden lg:block z-1"
                [warranty]="colorWarranty()"
                data-test-id="colorDetailsPage.colorWarranty"
                (ctaButtonClicked)="onColorWarrantyButtonClicked()" />
            }
          </div>
        </div>
        <div class="col-12 lg:col-6">
          <!-- Right content section -->
          <div
            #headerBannerContainer
            data-test-id="colorDetails.largeScreenHeaderBannerContainer"
            class="hidden lg:block">
            <ng-container *ngTemplateOutlet="headerBanner" />
          </div>
          <div class="flex flex-column gap-3">
            <ppg-color-details-description
              [isBestseller]="!!colorDetails()?.isBestSeller"
              [colorDescription]="colorDetails()?.description ?? ''"></ppg-color-details-description>
            <ppg-color-specification
              [supportMultipleFamilies]="areMultipleFamilyTypesEnabled()"
              [colorSpecification]="colorSpecification()!"
              [colorDataEnabled]="isColorDataSectionEnabled()"
              [rgbEnabled]="isColorDataRGBEnabled()"
              [lrvEnabled]="isColorDataLRVEnabled()"
              [ncsEnabled]="isColorDataNCSEnabled()"
              [colorFamiliesPath]="colorFamilyNavigationPath()"
              [colorCollectionPath]="colorCollectionNavigationPath()"
              (colorCollectionClick)="onColorCollectionClick()"
              (colorFamilyClick)="onColorFamilyClick()"></ppg-color-specification>
            @if (isFindAndBuySectionVisible()) {
              <h2 data-test-id="colorDetailsPage.findAndBuySectionHeadline">
                {{ resources().findAndBuySectionHeadline }}
              </h2>
              <div
                class="flex flex-column md:flex-row flex-wrap gap-4 find-and-buy-container"
                data-test-id="colorDetailsPage.findAndBuyButtons">
                @if (ctaShowProducts()?.content?.url) {
                  <div class="flex-1">
                    <p-button
                      styleClass="w-full h-full inline-flex flex-wrap align-content-center justify-content-center gap-1"
                      [outlined]="true"
                      (onClick)="navigateToShowProducts(ctaShowProducts())">
                      @if (ctaShowProducts()?.content?.icon) {
                        <ppg-image
                          [url]="ctaShowProducts()?.content?.icon?.url ?? ''"
                          width="auto"
                          height="auto"
                          [isResponsive]="false"></ppg-image>
                      }
                      {{ ctaShowProducts()?.content?.text }}
                    </p-button>
                  </div>
                }
                @for (findAndBuyCta of findAndBuyCtaItems(); track $index) {
                  @if (findAndBuyCta.content.url) {
                    <div class="flex-1">
                      <p-button
                        styleClass="w-full h-full inline-flex flex-wrap align-content-center justify-content-center gap-1"
                        [outlined]="true"
                        (onClick)="navigateToFindAndBuy(findAndBuyCta, $index)">
                        @if (findAndBuyCta.content.icon) {
                          <ppg-image
                            [url]="findAndBuyCta.content.icon.url"
                            width="auto"
                            height="auto"
                            [isResponsive]="false"></ppg-image>
                        }
                        {{ findAndBuyCta.content.text }}
                      </p-button>
                    </div>
                  }
                }
              </div>
            }
            @if (colorWarranty()) {
              <ppg-color-warranty
                class="block lg:hidden"
                [warranty]="colorWarranty()"
                data-test-id="colorDetailsPage.colorWarranty" />
            }
          </div>
        </div>
      </div>
    </section>
  }

  @if (coordinatingColors()) {
    <section class="section-container">
      <ppg-container-603010
        [model]="coordinatingColors()!"
        [fullWidth]="true"
        data-test-id="coordinatingColors"></ppg-container-603010>
    </section>
  }
</div>

<ng-template #headerBanner>
  <ppg-color-details-header-banner
    [isFavorite]="isFavorite()"
    [colorInfo]="colorDetails()!"
    [tintsAndShades]="tintsAndShades()"
    (toggleFavorite)="onFavoriteButtonClicked()"></ppg-color-details-header-banner>
</ng-template>
